import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Separator from "./Separator/separator";
import "./teamMembers.css";
import andreaImg from "../assets/team/andrea_guion.jpg";
import victoriaImg from "../assets/team/victoria_martins.jpg";
import claudiaImg from "../assets/team/claudia_prestes.jpg";
import isabellaImg from "../assets/team/isabella_moreira.jpg";
import jobertImg from "../assets/team/jobert_guirra.jpg";
import alessandraImg from "../assets/team/alessandra_guion.jpg";
import valterImg from "../assets/team/valter_guion.jpg";
import rafaelImg from "../assets/team/rafael_salles.jpg";
import eluzilayneImg from "../assets/team/eluzilayne_feitosa.jpg";

const teamMembers = [
    { name: "Dra. Andrea Fabiana Guion", specialty: "Endodontista e Clínica Geral", image: andreaImg, description: "Formada pela UNINOVE com especialidade em Endodontia pela UNIP. Também é enfermeira formada pelo Hospital Israelita Albert Einstein, com especialização em acupuntura e terapias orientais. Ao integrar diversas áreas da saúde, busca oferecer soluções inovadoras e personalizadas para atender às necessidades de cada paciente." },
    { name: "Dra. Victoria Martini", specialty: "Clínica Geral", image: victoriaImg, description: "Formada pela UNINOVE, possui curso de imersão em faceta de resina composta. Trabalha na área odontológica desde 2016, tendo começado como auxiliar de saúde bucal. Acredita que o carinho e o respeito são fundamentais para criar uma experiência acolhedora para os pacientes." },
    { name: "Dr. Valter Guion", specialty: "Clínico Geral", image: valterImg, description: "Formado há mais de 25 anos pela Universidade Federal de Alfenas, atua nas áreas de clínica geral, estética, próteses, periodontia e implantodontia. Busca sempre oferecer o melhor resultado para os pacientes." },
    { name: "Dra. Isabella Moreira Geraldi", specialty: "Clínica Geral", image: isabellaImg, description: "Formada pela Universidade Nove de Julho em 2022, é apaixonada por crianças e sorrisos saudáveis. Atua na área de odontopediatria e possui cursos de atualização em Endodontia e Cirurgia Oral Menor." },
    { name: "Dra. Cláudia Preste Poianas", specialty: "Ortodontista e Clínica Geral", image: claudiaImg, description: "Formada pela UMESP em 2007, atua nas áreas de pediatria e clínica geral. Possui especialização em ortodontia e ortopedia funcional dos maxilares. Capacitada com diversos tipos de aparelhos e Invisalign, adota uma abordagem personalizada para cada paciente." },    
    { name: "Dr. Jobert Guirra", specialty: "Bucomaxilofacial e Clínico Geral", image: jobertImg, description: "Cirurgião dentista especializado em traumatologia bucomaxilofacial. Atua também nas áreas de ortodontia, prótese dentária, estética dental e harmonização orofacial. Seu compromisso está em oferecer tratamentos inovadores e eficazes." },
    { name: "Dra. Alessandra Tribst Guion", specialty: "Ortodontista e Clínica Geral", image: alessandraImg, description: "Formada há mais de 25 anos na Universidade Federal de Alfenas, aplica seu conhecimento na área de ortodontia para manter os sorrisos alinhados e brilhantes. Também atua como clínica geral." },
    { name: "Dr. Rafael Salles de Camargo", specialty: "Clínica Geral", image: rafaelImg, description: "Formado pela Universidade Nove de Julho desde de 2022, atua na área desde de 2021 começando como estagiário. Está fazendo  especialização em Dentística e Prótese dentária e possui diversos cursos, como clareamento, endodontia e cirurgia oral menor." },
    { name: "Dra. Eluzilayne Feitosa J. Araújo", specialty: "Clínica Geral", image: eluzilayneImg, description: "Formada pela Universidade Nove de Julho em dezembro de 2023, tendo curso na área de Harmonização Orofacial. Atua na área da odontologia desde 2020, tendo começado como auxiliar de saúde bucal." }
  ];

const CustomPrevArrow = (props) => (
  <button className="custom-prev" aria-label="Previous Slide" onClick={props.onClick} style={{ left: "10px" }}>
    &#10094;
  </button>
);

const CustomNextArrow = (props) => (
  <button className="custom-next" aria-label="Next Slide" onClick={props.onClick} style={{ right: "10px" }}>
    &#10095;
  </button>
);

export default function Team() {
  const [expandedIndex, setExpandedIndex] = useState(null);
  
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true,
    prevArrow: <CustomPrevArrow />, 
    nextArrow: <CustomNextArrow />, 
    accessibility: true,
    centerMode: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
          centerMode: false,
          arrows: true,
        },
      },
    ],
  };

  const toggleExpand = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <section className="team-section" id="team">
      <div className="tit-sections">
        <h1>Nossa Equipe</h1>
        <Separator />
        <h2>"Profissionais altamente qualificados para proporcionar uma experiência de excelência"</h2>
      </div>
      <div className="team-slider-container">
        <Slider {...settings} className="team-slider">
          {teamMembers.map((member, index) => (
            <div key={index} className={`team-card ${expandedIndex === index ? 'active' : ''}`} tabIndex={0}>
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <p className="team-specialty">{member.specialty}</p>                    
              </div>
              <div className="team-image-wrapper">                    
                <img src={member.image} alt={member.name} className="team-image" />
              </div>
              <div className="team-info">
                <button className="team-button" onClick={() => toggleExpand(index)} tabIndex={0}>Saiba Mais</button>
                {expandedIndex === index && (
                  <div className="team-description" style={{ maxHeight: "200px", overflowY: "auto" }}>
                    <p>{member.description}</p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
